import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';

import { Topbar } from '../../components';

interface Props {
  authInProgress: boolean,
  currentPage?: string | null,
  currentSearchParams?: any,
  isAuthenticated: boolean,
  authScopes?: any,
  notificationCount?: number,
  onLogout: any,
  onManageDisableScrolling: any,
  hasGenericError: boolean,

}

const TopbarContainerComponent: React.FunctionComponent<Props> = (props: Props) => {
  const {
    authInProgress,
    currentPage,
    currentSearchParams,
    isAuthenticated,
    authScopes,
    hasGenericError,
    notificationCount,
    onLogout,
    onManageDisableScrolling,
    ...rest
  } = props;
  const location = useLocation()
  const params = useParams();
  return (
    <Topbar
      authInProgress={authInProgress}
      currentPage={currentPage}
      currentSearchParams={currentSearchParams}
      isAuthenticated={isAuthenticated}
      authScopes={authScopes}
      location={location}
      notificationCount={notificationCount}
      onLogout={onLogout}
      onManageDisableScrolling={onManageDisableScrolling}
      showGenericError={hasGenericError}
      match={{ params }}
      {...rest}
    />
  );
};


const mapStateToProps = (state: any) => {
  const { isAuthenticated, logoutError, authScopes } = state.auth;
  const hasGenericError = !!(logoutError);

  return {
    hasGenericError,
    isAuthenticated,
    authScopes,
  };
};

const mapDispatchToProps = () => ({

});

const TopbarContainer = compose<React.ElementType>(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(TopbarContainerComponent);

export default TopbarContainer;
